import { useEffect, useState } from "react";
import { Newspaper } from "lucide-react";
import api from "@/lib/api";

export default function News() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/news").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="section py-12 sm:py-16" data-testid="news-page">
      <p className="kicker mb-2">Press & Media</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl text-amber-50">Newsroom</h1>

      <div className="mt-10 grid gap-5 md:grid-cols-2">
        {items.map((n, i) => (
          <article key={n.id} className={`card-lux p-7 ${i === 0 ? "md:col-span-2" : ""}`} data-testid={`news-${i}`}>
            <p className="kicker mb-3 flex items-center gap-1.5"><Newspaper className="h-3 w-3" /> {n.category} · {new Date(n.created_at).toLocaleDateString(undefined, { month: "long", day: "numeric" })}</p>
            <h2 className={`font-serif text-amber-50 leading-tight ${i === 0 ? "text-3xl sm:text-4xl" : "text-2xl"}`}>{n.title}</h2>
            <p className="mt-3 text-amber-100/60">{n.excerpt}</p>
            <button className="mt-4 text-sm font-display uppercase tracking-wider text-gold hover:underline underline-offset-4">Read More</button>
          </article>
        ))}
      </div>
    </div>
  );
}
